import { SoleTrader } from '@monolith/legacy/types/sole-trader';
import http from '@monolith/legacy/services/api/http';

export const sendSoleTraderDetails = (soleTrader): Promise<SoleTrader> => {
  return http().patch('/api/me/retail/owner', soleTrader);
};
